<div class="ngx-messaging-chat__container">
  @if (!ui().isCreatingChannel) { @if (!ui().isFullScreenVideoCall) { @if (!ui().isLoadingChannel) { @if
  (chat().selectedChannel) {
  <section class="ngx-messaging-chat__content">
    @if (!hideConversation) {
    <div class="ngx-messaging-chat__header">
      <ngx-channel-header></ngx-channel-header>
    </div>
    <main class="ngx-messaging-chat__body">
      <ngx-channel-body (linkClicked)="handleLinkClick($event)"></ngx-channel-body>
    </main>
    } @if (chat().selectedChannel?.isMember && chat().selectedChannel?.member?.role !== ChannelRoles.VIEWER &&
    showInputSection()) {
    <footer class="ngx-messaging-chat__input">
      <ng-container *hasWorkspaceFeature="[WorkspaceFeatures.canUseAutoResponses]">
        <ngx-standard-responses></ngx-standard-responses>
      </ng-container>
      <ngx-channel-input></ngx-channel-input>
    </footer>
    }
  </section>
  @if (!hideConversation) {
  <section class="ngx-messaging-chat__right-sidebar">
    @if (smartRepliesService.showSmartReplies && !chat().selectedChannel?.hideSmartReplies && showInputSection()) {
    <ng-container *hasWorkspaceFeature="[WorkspaceFeatures.canUseSmartResponses]">
      <section class="ngx-messaging-chat__right-sidebar__sections" [ngClass]="{ isMobile: isMobile }">
        <smart-replies></smart-replies>
      </section>
    </ng-container>
    } @if (chat().sidebarVisible) {
    <section class="ngx-messaging-chat__right-sidebar__sections">
      <ngx-channel-info (orderIdEvent)="emitOrderIdEvent($event)"></ngx-channel-info>
    </section>
    }
  </section>
  } } @else {
  <ngx-channel-blank class="ngx-messaging-chat__full-container"></ngx-channel-blank>
  } } @else {
  <ngx-channel-skeletons class="ngx-messaging-chat__full-container"></ngx-channel-skeletons>
  } } @if (videoCall()) {
  <section class="ngx-messaging-chat__video" [class.ngx-messaging-chat__video--fullscreen]="ui().isFullScreenVideoCall">
    <ngx-video-conference [expand]="true"></ngx-video-conference>
  </section>
  } } @else {
  <ngx-text-spinner [text]="'Creating Channel'" class="ngx-messaging-chat__full-container"></ngx-text-spinner>
  }
</div>

<div hidden>Version {{ appVersion }}</div>
<div hidden>{{ url() }}</div>
